class AlgoliaHitCarousel extends HTMLElement {
  constructor() {
    super();
    this.render = this.render.bind(this);
  }

  /**
   * Renders and returns content.
   * @param {string} handle - The shopify product handle
   * @param {Object} colorOptions - The object with key pair values of color options available for this hit.
   * @param {string} cardColor - used to determine which image should be active on the first render
   * @param {function} mouseOverCB - Callback function triggered on thumbnail mouseover
   * @param {function} mouseOutCB - Callback function triggered on thumbnail mouseout
   * @param {function} clickCB - Callback function triggered on thumbnail click
   * @param {strine} mediaCameraShy - fallback image url to use if image doesn't load
   * @param {string} displayType - The display type: "thumbnail" or "color_swatch"
   * @returns {string} The rendered content HTML.
   */
  render(handle, colorOptions = {}, cardColor, mouseOverCB, mouseOutCB, clickCB, mediaCameraShy, displayType = 'color_swatch') {
    const carouselEl = this.cloneNode(true);
    const sliderWrapper = carouselEl.querySelector('ul');
    sliderWrapper.id = `Slider-${handle}`;

    Array.from(Object.keys(colorOptions)).forEach((option, ind) => {
      let optionFrame;

      if (displayType === 'color_swatch') {
        // When color_swatch type is selected, skip options without hexcode
        if (!colorOptions[option].hexcode) {
          return;
        }
        const colorSwatch = document.createElement('div');
        colorSwatch.classList.add('algolia-carousel__color-swatch');
        colorSwatch.style.backgroundColor = colorOptions[option].hexcode.startsWith('#') ?
          colorOptions[option].hexcode :
          `#${colorOptions[option].hexcode}`;
        colorSwatch.setAttribute('src', colorOptions[option].thumbnailFrontUrl);
        colorSwatch.setAttribute('alt', option);
        colorSwatch.setAttribute('aria-label', option);
        optionFrame = colorSwatch;
      } else {
        // When thumbnail type is selected, skip options without thumbnail
        if (!colorOptions[option].thumbnailFrontUrl) {
          return;
        }
        const img = document.createElement('img');
        img.alt = option;
        img.src = colorOptions[option].thumbnailFrontUrl;
        img.setAttribute('onerror', `this.onerror=null;this.src='${mediaCameraShy}'`);
        optionFrame = img;
      }
      // if there is no optionFrame created, skip adding it to the carousel as there is no media
      // to show for this option
      if (!optionFrame) return;
      const li = document.createElement('li');
      li.classList.add('slider__slide', 'grid__item', 'algolia-hit-slider');
      li.id = `Slide-${handle}-${option}`
      li.appendChild(optionFrame);

      if (mouseOverCB) optionFrame.addEventListener('mouseenter', mouseOverCB);
      if (mouseOutCB) optionFrame.addEventListener('mouseout', mouseOutCB);
      if (clickCB) optionFrame.addEventListener('click', clickCB);

      if (cardColor === option) {
        optionFrame.classList.add('active');
        // the first color in the colorOptions is not always the same as the card color
        // we're force inserting the matching color to the start of
        sliderWrapper.insertBefore(li, sliderWrapper.firstChild);
      } else {
        sliderWrapper.appendChild(li);
      }
    });

    // Hide carousel if no options were added
    if (sliderWrapper.children.length === 0) {
      carouselEl.style.display = 'none';
    }

    return carouselEl;
  }  
}

customElements.define("algolia-hit-carousel", AlgoliaHitCarousel);
